import type { DefaultTheme } from 'styled-components';

export interface PolyLoaderConfig {
  fill: string;
  stroke: string;
  fillActive: string;
  strokeActive: string;
}

export function getPolyLoaderConfig(
  theme: DefaultTheme,
): Record<string, PolyLoaderConfig> {
  return {
    greyscale: {
      fill: theme.activeColorScheme.colors.backgroundDisabledStrong,
      stroke: theme.activeColorScheme.colors.backgroundDisabledStrong,
      fillActive: theme.activeColorScheme.colors.iconPrimaryBrand,
      strokeActive: theme.activeColorScheme.colors.iconPrimaryBrand,
    },
    logo: {
      fill: theme.activeColorScheme.colors.background,
      stroke: theme.activeColorScheme.colors.background,
      fillActive: theme.activeColorScheme.colors.iconBrand,
      strokeActive: theme.activeColorScheme.colors.iconBrand,
    },
  };
}
